module.exports = __webpack_public_path__ + "img/icon_user.eaffd1c2.png";